// 用户api
import request from "./api";

// export const goLongin = (params, opts) => request("/api-oauth/oauth2/token", params, { ...opts, method: "post", });


export const postGoOut = (params, opts) =>
  request("/api-oauth/oauth2/logout", params, {
    ...opts,
    method: "post",
  });

// 登录-获取token
export const goLongin = (params, opts) => request("/api-oauth/oauth2/token", params, { ...opts, method: "post", });
// 获取单项评分院校集合
export const getDeptIds = (params, opts) => request("/api-user/sys/deptDetial/queryAll", params, opts);
// 获取验证码图片
export const getCode = (params, opts) => request("/api-oauth/validata/code", params, opts);
// 获取机构下有没有此用户
export const findUser = (params, opts) => request("/api-user/sys/user/findUser", params, opts);
// getUser
export const getUser = (params, opts) => request("/api-oauth/oauthclient/getUser", params, { ...opts, method: "post", contentType: "application/x-www-form-urlencoded", });
// 获取菜单
export const findMenu = (params, opts) => request("/api-user/sys/menu/findMenuTreeNewAndBtn", params, { ...opts, method: "post"});
export const newFindMenu = (params, opts) => request("/api-user/sys/menu/findMenuTreeNewAndBtnByProdId", params, { ...opts, method: "post"});
// 退出
export const logout = (token, params, opts) => request("/api-oauth/oauth2/exit/"+token, params, opts);
// 校验当前token是否失效
export const isExpired = (token, params, opts) => request("/api-oauth/oauth2/token/expired?token="+token, params, opts)
// 申请试用
export const applyFor = (params, opts) => request("/api-msg/msg/v1/save", params, { ...opts, method: "post"})
// 完善个人信息
export const updateUserPasswordInfo = (params, opts) => request("/api-user/sys/user/updateUserPasswordInfo", params, { ...opts, method: "post"})
// 完善个人信息 解绑手机号
export const userPhoneUnbind = (params, opts) => request("/api-user/sys/user/userPhoneUnbind", params, { ...opts, method: "post"})
// 完善信息获取验证码
export const sendMessage = (params, opts) => request("/api-teachingaffair/teachingAffair/sendMessage", params, { ...opts, method: "post"})
// 忘记密码获取验证码
export const getPhoneCode = (params, opts) => request("/api-user/sys/user/aliyunSms", params, { ...opts, method: "post"})
// 忘记密码提交
export const foundByTel = (params, opts) => request("/api-user/sys/user/foundByTel", params, { ...opts, method: "post"})

// 获取个人信息
export const getUserInfo = (params, opts) => request("/api-teachingaffair/teachingAffair/getUserInfo", params, opts)
// 修改个人信息
export const updateUserInfo = (params, opts) => request("/api-teachingaffair/teachingAffair/updateUserInfo", params, { ...opts, method: "post"})
// 修改密码
export const updatePassword = (params, opts) => request("/api-user/sys/user/password", params, { ...opts, method: "post"})
// 退出
export const updatePasswordLogout = (token, params, opts) => request("/api-oauth/oauth2/logout?access_token="+token, params, { ...opts, method: "post"})
// 修改手机号
export const updateUserInfoSafe = (params, opts) => request("/api-teachingaffair/teachingAffair/updateUserInfoSafe", params, { ...opts, method: "post"})
// 判断选择账套数量
export const intoSysJudge = (params, opts) => request("/api-study/appCenter/selectAppCenterRecords", params, { ...opts, method: "post"})
// 进入系统账套选择
export const selectSysJudge = (params, opts) => request("/api-study/appCenter/appCenterRecords", params, { ...opts, method: "post"})

// 首页-获取常用入口列表
export const getCommonEntrance = (params, opts) => request("/api-user/sys/prod/queryAllUsed", params, opts)
// 首页-删除常用入口
export const deleteCommonEntrance = (params, opts) => request("/api-user/frequentlyUsedUsers/deleteUsed", params, { ...opts, method: "post"})
// 首页-设为常用入口
export const setCommonEntrance = (params, opts) => request("/api-user/frequentlyUsedUsers/setUsed", params, { ...opts, method: "post"})
// 首页-查询全部应用
export const getAllProd = (params, opts) => request("/api-user/sys/prod/queryDeptProdList", params, { ...opts, method: "post"})
// 首页-查询全部分类
export const queryAllProdClass = (params, opts) => request("/api-user/sys/prod/findProdClass", params, { ...opts, method: "post"})
// 首页-查询全部应用类型
export const getApplicationTypeIdList = (params, opts) => request("/api-user/sys/application/type/queryAll", params, opts)
// 首页-查询全部专业大类
export const getSpecialtyList = (params, opts) => request("/api-user/sys/product/specialty/queryAll", params, opts)
// 首页-常用入口排序
export const sortUsed = (params, opts) => request("/api-user/FrequentlyUsedUserSort/sortUsed", params, { ...opts, method: "post"})

// 登录-获取组织id
export const queryUserStruct = (params, opts) => request("/api-user/sys/struct/queryUserStruct", params, opts)
// 产品人数上限校验
export const countLoginNumber = (params, opts) => request("/api-user/sys/menu/countLoginNumber", params, { ...opts, method: "post"})
export const exitLoginNumber = (params, opts) => request("/api-user/sys/menu/exitLogin", params, { ...opts, method: "post"})

// 单独跳转页
export const otherSystemLogin = (params, opts) => request("/api-user/sys/user/otherSystemLogin", params, { ...opts, method: "post", });
// 单独跳转页1
export const otherSystemLoginGlgzy = (params, opts) => request("/api-user/sys/user/otherSystemLogin-glgzy", params, { ...opts, method: "post", });




// WEBPACK FOOTER //
// ./src/api/userApi.js